import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  // Get current year for copyright
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        {/* Single row with horizontal links and social media */}
        <div className="footer-horizontal">
          {/* Quick links section */}
          <div className="quick-links">
            {/* Fix empty href by using button */}
            <button 
              onClick={(e) => { 
                e.preventDefault(); 
                window.scrollTo({top: 0, behavior: 'smooth'}); 
              }}
              className="quick-link-button"
              style={{
                background: "transparent",
                border: "none",
                color: "#dddddd",
                fontSize: "15px",
                cursor: "pointer",
                padding: 0,
                position: "relative",
                transition: "all 0.3s ease"
              }}
            >
              Home
            </button>
            <a href="#classes">Classes</a>
            <a href="#pricing">Pricing</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
          </div>

          {/* Social media section */}
          <div className="social-links">
            <a href="https://www.instagram.com/mkailashba" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fa fa-instagram"></i>
            </a>
            <a href="mailto:yoga.nachiketa@gmail.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fa fa-envelope"></i>
            </a>
            <a href="https://wa.me/919173935040?text=Hi%2C%20I%27m%20interested%20in%20yoga%20classes" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fa fa-whatsapp"></i>
            </a>
          </div>
        </div>

        <div className="footer-divider"></div>

        <Row>
          <Col md={6} className="text-center text-md-start">
            <div className="copyright">
              <p>
                &copy; {currentYear} <span className="brand-name">Nachiketa Yoga</span> | Best Yoga Classes in Bopal, Ahmedabad
              </p>
            </div>
          </Col>

          <Col md={6} className="text-center text-md-end">
            <div className="developer-credits">
              <p>
                Developed with <i className="fa fa-heart developer-heart"></i> by 
                <a href="https://pratiksinh-makwana.vercel.app/" target="_blank" rel="noopener noreferrer" className="developer-link"> Pratik</a>
                <a href="https://github.com/pratik2542" target="_blank" rel="noopener noreferrer" className="social-link social-link-small">
                  <i className="fa fa-github"></i>
                </a>
                <a href="https://www.linkedin.com/in/pratiksinh-makwana-43488a189/" target="_blank" rel="noopener noreferrer" className="social-link social-link-small">
                  <i className="fa fa-linkedin"></i>
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
